export const APP_STORE_URL =
  "https://apps.apple.com/us/app/zoopers-now/id6762121370";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.zoopers.app&hl=en_IN";

export const navLinks = [
  { label: "Services", href: "#services" },
  { label: "Prices", href: "#pricing" },
  { label: "Why Us", href: "#why" },
  { label: "How it Works", href: "#how" },
  { label: "FAQ", href: "#faq" },
];

export const howItWorks = [
  {
    icon: "MapPin",
    title: "Near You",
    desc: "Schedule a pickup from your location",
  },
  {
    icon: "ListChecks",
    title: "Your Way",
    desc: "Choose service & instructions",
  },
  {
    icon: "Ruler",
    title: "Measurement",
    desc: "Precise fitting at your doorstep",
  },
  { icon: "Truck", title: "On the Way", desc: "Delivered back to your door" },
];

export const services = [
  {
    key: "stitching",
    title: "Tailoring",
    desc: "Custom tailored garments crafted with precision.",
    image:
      "https://images.unsplash.com/photo-1606501126768-b78d4569d3f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    startsAt: "₹1399",
  },
  {
    key: "alteration",
    title: "Alteration",
    desc: "Perfect fit for the clothes you love.",
    image:
      "https://images.unsplash.com/photo-1578353022142-09264fd64295?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    startsAt: "₹99",
  },
  {
    key: "laundry",
    title: "Laundry",
    desc: "Fresh & spotless wash, delivered fast.",
    image:
      "https://images.unsplash.com/photo-1466837581110-aeaa58fb562f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    startsAt: "₹245 / 5kg",
  },
  {
    key: "ironing",
    title: "Ironing",
    desc: "Crisp, wrinkle-free finish every time.",
    image:
      "https://images.unsplash.com/photo-1489274495757-95c7c837b101?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    startsAt: "₹12 / Piece",
  },
];

export const stylePoints = [
  { icon: "Sparkles", label: "Trendy twists" },
  { icon: "Scissors", label: "Bespoke fixes" },
  { icon: "Lightbulb", label: "Innovative" },
  { icon: "User", label: "Personalised" },
  { icon: "Key", label: "Unique solutions" },
];

export const pricing = [
  {
    icon: "Scissors",
    title: "Tailoring",
    price: "₹ 1399",
    note: "Price starts from",
    sub: "",
  },
  {
    icon: "Ruler",
    title: "Home Alteration",
    price: "₹ 99",
    note: "Price starts from",
    sub: "",
    featured: true,
  },
  {
    icon: "WashingMachine",
    title: "Laundry & Dry-Cleaning",
    price: "₹ 245",
    note: "Starts from on 5kgs",
    sub: "(₹49/KG)",
  },
  {
    icon: "Shirt",
    title: "Ironing",
    price: "₹ 12",
    note: "Starts from",
    sub: "/Piece",
  },
];

export const whyChooseTiles = [
  {
    title: "100% Dedication",
    subtitle: "Verified and Trusted Experts",
    cta: "Read Reviews",
    icon: "ShieldCheck",
    bg: "bg-[#FCE1EE]",
    accent: "text-[#E91E80]",
    btn: "bg-[#E91E80] hover:bg-[#D1176E]",
    href: "#reviews",
  },
  {
    title: "Quick on Time",
    subtitle: "Perfect in Quality.",
    cta: "View Services",
    icon: "Timer",
    bg: "bg-[#FDE1CE]",
    accent: "text-[#F27430]",
    btn: "bg-[#F27430] hover:bg-[#DB6828]",
    href: "#services",
  },
  {
    title: "Freedom to Cancel or Reschedule",
    subtitle: "Place your first order now",
    cta: "Schedule now",
    icon: "CalendarCheck",
    bg: "bg-[#D6EBD8]",
    accent: "text-[#2E9A47]",
    btn: "bg-[#2E9A47] hover:bg-[#278A3E]",
    href: "#",
  },
  {
    title: "Delivery Time",
    subtitle: "Tailoring - 3 Days · Alteration, Laundry & Ironing - 6 hrs",
    cta: "Know more",
    icon: "Truck",
    bg: "bg-[#DCEAF7]",
    accent: "text-[#2A7BC9]",
    btn: "bg-[#2A7BC9] hover:bg-[#256DB2]",
    href: "#faq",
  },
];

export const seamlessTabs = {
  Tailoring: [
    {
      title: "Select Design",
      desc: "Choose your style from our collection or provide your own.",
      icon: "PenTool",
    },
    {
      title: "Provide Measurements",
      desc: "We arrange a pickup for your measurement garment or fabric.",
      icon: "Ruler",
    },
    {
      title: "Expert Tailoring",
      desc: "Our tailors craft your garment with precision and care.",
      icon: "Scissors",
    },
    {
      title: "Quality Check & Delivery",
      desc: "Your new garment is delivered to your doorstep.",
      icon: "Truck",
    },
  ],
  "Home Alterations": [
    {
      title: "Book Pickup",
      desc: "Schedule a doorstep pickup at your convenience.",
      icon: "CalendarCheck",
    },
    {
      title: "Share Requirements",
      desc: "Tell us what needs to be altered — length, fit, or style.",
      icon: "ListChecks",
    },
    {
      title: "Precision Alteration",
      desc: "Our experts refine your garment to perfection.",
      icon: "Scissors",
    },
    {
      title: "Instant Home alterations",
      desc: "Expert Tailors at Home in 10Mins",
      icon: "Truck",
    },
  ],
  "Laundry & Dry-Cleaning": [
    {
      title: "Pickup Scheduled",
      desc: "We collect your clothes right from your doorstep.",
      icon: "MapPin",
    },
    {
      title: "Sort & Clean",
      desc: "Careful washing with premium detergents.",
      icon: "WashingMachine",
    },
    {
      title: "Wash to Perfection",
      desc: "Crisp ironing for a wrinkle-free finish.",
      icon: "Shirt",
    },
    {
      title: "Doorstep Delivery",
      desc: "Fresh, folded and delivered in 6 hours.",
      icon: "Truck",
    },
  ],
  "Ironing": [
    {
      title: "Pickup Scheduled",
      desc: "We collect your clothes right from your doorstep.",
      icon: "MapPin",
    },
    {
      title: "Sort & Clean",
      desc: "Careful washing with premium detergents.",
      icon: "WashingMachine",
    },
    {
      title: "Pressed to Perfection",
      desc: "Crisp ironing for a wrinkle-free finish.",
      icon: "Shirt",
    },
    {
      title: "Doorstep Delivery",
      desc: "Fresh, folded and delivered in 6 hours.",
      icon: "Truck",
    },
  ],
};

export const faqs = [
  {
    q: "What is Zoopers?",
    a: "Zoopers is an online platform offering doorstep tailoring, alterations, and laundry services with same-day delivery through a quick commerce model.",
  },
  {
    q: "What are the starting prices of your services?",
    a: "Tailoring starts from ₹1399, Alteration from ₹99, Laundry from ₹245 for 5kgs (₹49/KG), and Ironing from ₹12 per piece.",
  },
  {
    q: "How does the tailoring service work?",
    a: "Schedule a pickup, share your design and measurements. Our women expert tailors craft your garment with precision and deliver it back to your doorstep.",
  },
  {
    q: "What is turnaround time for your services?",
    a: "Tailoring takes 3 days. Alteration in 30mins, laundry & ironing are delivered within 6 hours.",
  },
  {
    q: "What is the delivery time for stitched clothes?",
    a: "Stitched garments are delivered within 3 days of measurement pickup.",
  },
  {
    q: "What types of clothes can I get stitched?",
    a: "From ethnic wear like sarees, blouses, salwar suits to western wear — our tailors handle it all.",
  },
  {
    q: "Do you offer pickup and delivery?",
    a: "Yes, we offer free doorstep pickup and delivery across serviceable areas.",
  },
  {
    q: "Where is Zoopers currently available?",
    a: "Zoopers is currently available in Bengaluru with expansion to more cities coming soon.",
  },
  {
    q: "How do you handle delicate or expensive fabrics?",
    a: "We use specialized handling, hand-wash processes and dedicated experts for delicate & premium fabrics.",
  },
  {
    q: "What if I'm not satisfied with the alteration?",
    a: "We offer free re-alteration within 3 days if the fit is not to your liking.",
  },
];

export const testimonials = [
  {
    name: "Sunitha",
    rating: 5,
    text: "Zoopers's alteration service is a lifesaver! They perfectly resized my favorite dress in just one day. The fit is incredible, and the service was so convenient. Highly recommend!",
  },
  {
    name: "Lakshmi",
    rating: 5,
    text: "I had my saree and blouse stitched from Zoopers, and the fit was absolutely perfect. The design captured my style beautifully, with flawless finishing and elegant detailing.",
  },
  {
    name: "Abdul",
    rating: 5,
    text: "Their laundry and ironing service is the best. My clothes always come back fresh, clean, and perfectly pressed. It saves me so much time and effort. Absolutely worth it!",
  },
  {
    name: "Sreedevi",
    rating: 4.5,
    text: "Zoopers's laundry and ironing service is top-notch. My clothes come back spotless, fresh, and neatly pressed every time. Reliable, convenient, and saves a lot of hassle.",
  },
  {
    name: "Rahul",
    rating: 5,
    text: "Booked stitching for a wedding sherwani. The fit was perfect and delivered right on time. Zoopers has become my go-to for anything clothing-related.",
  },
  {
    name: "Priya",
    rating: 5,
    text: "Loved the doorstep experience. The measurement expert was polite, professional and got the fit spot-on. Highly recommend for busy professionals!",
  },
];
